import { render, staticRenderFns } from "./VuesticSocialNews.vue?vue&type=template&id=44d32212"
import script from "./VuesticSocialNews.vue?vue&type=script&lang=js"
export * from "./VuesticSocialNews.vue?vue&type=script&lang=js"
import style0 from "./VuesticSocialNews.vue?vue&type=style&index=0&id=44d32212&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d32212')) {
      api.createRecord('44d32212', component.options)
    } else {
      api.reload('44d32212', component.options)
    }
    module.hot.accept("./VuesticSocialNews.vue?vue&type=template&id=44d32212", function () {
      api.rerender('44d32212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-social-news/VuesticSocialNews.vue"
export default component.exports